import { render, staticRenderFns } from "./App.vue?vue&type=template&id=6b3d5f45&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b3d5f45')) {
      api.createRecord('6b3d5f45', component.options)
    } else {
      api.reload('6b3d5f45', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=6b3d5f45&", function () {
      api.rerender('6b3d5f45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/views/App.vue"
export default component.exports